import axios from "@/plugins/axios";

// Perbelanjaan Isi Rumah Bulanan mengikut Kumpulan Etnik (Kaum) & Strata.
// Expenditure version of kaumXstrata.js. Combines Purata + Penengah into one
// kaum × strata table (Bandar / Luar Bandar / Jumlah per year). By default ALL years
// (incl. the latest) come from the precomputed `lampiran_negxkaumxstrata` /
// `negxdaerahxkaum` / `negxdaerahxstrata` / `negxdaerah` tables (TW_/W_purata_perbelanjaan
// cols) so they match the official figures; a backend code toggle (LATEST_FROM_HID in
// getPerbelanjaanPurataLampiran.js) switches the latest year to a live `lampiran_hid_perbelanjaan` calc.
// `data.purata` / `data.penengah` each hold rows of
// { kaum, strata:{ Bandar:{y:v}, 'Luar Bandar':{y:v}, Jumlah:{y:v} } }.
export default class perbelanjaanKaumStrataServices {
  // params: { NG?, DP?, P (csv pusingan), S ("1"|"2"|"3"), W ("W"|"TW") }
  async getPerbelanjaanKaumStrata(params = {}) {
    const res = await axios.get(
      `${process.env.VUE_APP_API_URL}/JadualAwalan/getPerbelanjaanKaumStrataLampiran`,
      { params }
    );
    return (res.data && res.data.data) || {};
  }
}
